<template>
    <b-modal
        hide-footer
        id="info-tire-size"
        title="Tire Size"
        v-model="visible"
        size="md"
    >
        <ul>
            <li>Width – This information can be obtained from the side of the tire</li>
            <li>Aspect – This information can be obtained from the side of the tire</li>
            <li>Diameter – This information can be obtained from the side of the tire</li>
        </ul>
    </b-modal>
</template>

<script>
export default {
    data: () => ({
        visible: false,
    }),
}
</script>
